<template>
  <div
    class="group relative shrink-0 h-10 w-40 flex items-center gap-2 px-2.5 py-1 bg-nera-chip-bg hover:bg-nera-chip-bg-hover border border-nera-chip-border hover:border-nera-chip-border-hover rounded-lg text-xs transition-colors duration-200">
    <i :class="fileIconClass" class="text-nera-muted shrink-0"></i>
    <span class="flex-1 min-w-0 truncate font-medium text-nera-text">{{ fileName }}</span>
    <span class="shrink-0 uppercase tracking-wide text-nera-muted">{{ fileExtension }}</span>

    <div
      class="absolute inset-0 rounded-lg bg-white/85 backdrop-blur-sm flex items-center justify-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-150 delay-0 group-hover:delay-200">
      <button @click.stop="$emit('remove')"
        class="inline-flex items-center justify-center w-7 h-7 rounded-full text-nera-muted hover:bg-nera-light-hover hover:text-nera-text transition-colors"
        title="Remove from chat">
        <i class="fas fa-times text-sm"></i>
      </button>
      <button @click.stop="$emit('delete')"
        class="inline-flex items-center justify-center w-7 h-7 rounded-full text-nera-danger hover:bg-nera-danger/10 hover:text-nera-danger-hover transition-colors"
        title="Delete permanently">
        <i class="fas fa-trash-alt text-sm"></i>
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  file: { type: Object, required: true }
})

defineEmits(['remove', 'delete'])

const fileIconClass = computed(() => {
  if (props.file.type?.includes('csv')) return 'fas fa-file-csv'
  if (props.file.type?.includes('excel') || props.file.type?.includes('spreadsheet')) return 'fas fa-file-excel'
  return 'fas fa-file'
})

const fileName = computed(() => props.file.filename || props.file.name || 'unknown')

const fileExtension = computed(() => {
  const name = props.file.filename || props.file.name || ''
  const ext = name.split('.').pop()
  return ext ? ext.toLowerCase() : '—'
})
</script>
